// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"4576b1fe","455":"5a43ef88","460":"94a4f244","487":"d5907da3","497":"439fd753","604":"0d47873e","683":"e10c2c21","687":"5f76f49a"}[chunkId] + ".chunk.js";
};